<template>
  <div class="relative">
    <label
      v-for="(radio, index) in radios"
      :key="radio.label"
      class="inline-flex items-center flex-wrap my-2"
      :class="{ 'ml-4': index > 0 }"
    >
      <VRadio
        :value="radio.value"
        v-model="modelRadio"
        @change="onChange"
      />

      <span
        slot="label-left"
        class="inline-block text-xs pl-2 leading-none"
        :class="$style['label-color']"
      >
        {{ radio.label }}
      </span>
    </label>

    <div
      v-if="iconName"
      class="absolute pin-t flex items-center h-full text-xl"
      :class="[$style['icon'], { 'text-success-50': valid, 'text-danger-50': invalid }]"
    >
      <VIcon :name="iconName" />
    </div>

    <slot name="error">
      <div
        v-if="error"
        class="-mt-1 text-2xs text-danger-50 mb-1"
      >
        {{ error }}
      </div>
    </slot>
  </div>
</template>

<script>
import {
  VIcon,
  VRadio
} from '@c/base'

export default {
  components: {
    VIcon,
    VRadio
  },

  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Boolean],
      default: null
    },
    radios: {
      type: Array,
      required: true
    },
    valid: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      modelRadio: this.value
    }
  },

  computed: {
    iconName () {
      if (this.invalid) {
        return 'exclamation-circle'
      }

      return this.valid
        ? 'check'
        : null
    }
  },

  methods: {
    onChange (radio) {
      this.$emit('input', this.modelRadio)
      this.$emit('change', radio)
    }
  }
}
</script>

<style module>
.icon {
  right: -30px;
}
</style>
